import { render, staticRenderFns } from "./GBoothPreviewForm.vue?vue&type=template&id=154400b4&scoped=true&"
import script from "./GBoothPreviewForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothPreviewForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothPreviewForm.vue?vue&type=style&index=0&id=154400b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154400b4",
  null
  
)

export default component.exports